// Haptic feedback via the Vibration API (Android/Chrome). Silent no-op elsewhere.
const KEY = "rl_haptics_off";
export const hapticsEnabled = () => localStorage.getItem(KEY) !== "1";
export const setHaptics = (on) => localStorage.setItem(KEY, on ? "0" : "1");
const buzz = (pattern) => { try { if (hapticsEnabled() && navigator.vibrate) navigator.vibrate(pattern); } catch {} };

export const haptic = {
  tap: () => buzz(12),
  flip: () => buzz([10, 30, 10]),
  land: () => buzz([40, 40, 25]),
  tease: () => buzz([15, 60, 15, 70, 15, 90, 15, 120, 45]),
  crash: () => buzz([80, 40, 80, 40, 120]),
  win: () => buzz([30, 50, 30, 50, 60]),
  bigWin: () => buzz([60, 40, 60, 40, 60, 40, 200]),
};
